<template>
    <div>
        <iframe ref="iframeUrl" :src="url" class="preview-frame" title="urlPreview"></iframe>
    </div>
</template>

<script>
    export default {
        props: {
            id: { type: Number, required: true },
            name: { type: String, required: true },
            url: { type: String, required: true }
        },

        mounted() {
            this.$_setDocumentTitle();
            this.$_setStyleNonScopedElements();
            this.$_subscribeToWindowsMessages();
        },

        methods: {
            $_subscribeToWindowsMessages() {
                window.addEventListener('unload', this.$_logout, false);
            },

            async $_logout() {
                await this.$store.dispatch('useApiData', {
                    name: 'Logout',
                    parameters: { OrganizationUrlConnectionId: this.id },
                    config: { timeout: 0 }
                })
                .then(() => {
                    console.log('UrlConnection logout succeeded');
                }, (error) => {
                    console.log(`UrlConnection logout error: ${error}`);
                });
            },

            $_setStyleNonScopedElements() {
                document.querySelector('html').style.height = '100%';
                document.querySelector('body').style.height = '100%';
                document.querySelector('div').style.height = '100%';
            },

            $_setDocumentTitle() {
                document.title = this.name;
            },
        }
    };
</script>

<style scoped>
    div {
        height: 100%;
    }

    .preview-frame {
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
